import { zustandStore } from "@/app/zustand-store";

export const useZStore = zustandStore;
